import {
  RETRIEVE_SPACES,
  UPDATE_SPACE_STATUS,
  UPDATE_IS_ACTIVE,
  DELETE_SPACE,
  RESTORE_SPACE,
  UPDATE_SPACE_IS_AVAILABLE,
} from "../actions/types";

const initialState = { spaces : [], totalSpaceCount : 0 };

const spaceReducer = (state = initialState, action) => {

  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_SPACES:
      return {
        spaces: payload.rows,
        totalSpaceCount: payload.count,
      };

    case UPDATE_SPACE_STATUS:
      return {
        spaces: payload.rows,
        totalSpaceCount: payload.count,
      };

    case UPDATE_IS_ACTIVE:
      return {
        spaces: payload.rows,
        totalSpaceCount: payload.count,
      };

    case DELETE_SPACE:
      return {
        spaces: payload.rows,
        totalSpaceCount: payload.count,
      };

    case RESTORE_SPACE:
      return {
        spaces: payload.rows,
        totalSpaceCount: payload.count,
      };

    case UPDATE_SPACE_IS_AVAILABLE:
      return {
        ...state,
        spaces: (state.spaces || []).map((space) =>
          space.id === payload.id ? { ...space, isAvailable: payload.isAvailable } : space
        ),
      };

    default:
      return state;
  }
};

export default spaceReducer;